import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import commonActions from '../Actions/commonActions';

// Stable function identities so consumers can list them in effect dependencies.
const useModal = () => {
    const dispatch = useDispatch();
    const activeModal = useSelector((state) => state.CommonReducer.currentlyActiveModal);

    const openModal = useCallback((modalId) => {
        dispatch(commonActions.activateModal(modalId));
    }, [dispatch]);

    const closeModal = useCallback(() => {
        dispatch(commonActions.activateModal(null));
        dispatch(commonActions.hideAlert());
    }, [dispatch]);

    const isModalOpen = useCallback((modalId) => activeModal === modalId, [activeModal]);

    return {
        isModalOpen,
        openModal,
        closeModal,
    };
};

export default useModal;
